import { render, staticRenderFns } from "./SavedFiltersIcon.vue?vue&type=template&id=14b228e0&scoped=true"
import script from "./SavedFiltersIcon.vue?vue&type=script&lang=js"
export * from "./SavedFiltersIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b228e0",
  null
  
)

export default component.exports